import { APICallV2Post } from 'reactApp/api/APICall';
import { CloudActions } from 'reactApp/constants/cloudActions';

const method = 'folder/add';

export class AddFolderAPIV2Call extends APICallV2Post {
    _method = method;
    _headers = { 'X-VFS-Action': CloudActions.FOLDER_CREATE };
}
